// ACOS
export const COMMUNICATE_ERROR_MESSAGE_ACOS_INDEX = 'WX_WNI_VolcanicAshConcVector/index';
export const COMMUNICATE_ERROR_MESSAGE_ACOS_2D = 'WX_WNI_VolcanicAshConcVector/2D/$volcano$';
export const COMMUNICATE_ERROR_MESSAGE_ACOS_3D = 'WX_WNI_VolcanicAshConcVector/3D/$volcano$';
export const COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicAsh_GPV = 'WX_WNI_VolcanicAsh_GPV $data$';
export const COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicRank = 'WX_WNI_VolcanicRank data';
// FIR
export const COMMUNICATE_ERROR_MESSAGE_FIR = 'auth/fir';
// AircraftSetting
export const COMMUNICATE_ERROR_MESSAGE_AIRCRAFT_LIST = 'aircraft_linkage/aircraft/list';
export const COMMUNICATE_ERROR_MESSAGE_AIRCRAFT_AIRCRAFTGROUP_LIST = 'links/aircraft_aircraftgroup_list';
export const COMMUNICATE_ERROR_MESSAGE_AIRCRAFTGROUP_LIST = 'links/aircraftgroup_list';
export const COMMUNICATE_ERROR_MESSAGE_SHARED_DESTINATION_LIST = 'aircraft_linkage/aircraftgroup/shared_destination_list';
export const COMMUNICATE_ERROR_MESSAGE_USERGROUP_LIST = 'app_fosterlinks/usergroup/list';
export const COMMUNICATE_ERROR_MESSAGE_USERGROUP_AIRCRAFTGROUP_LIST = 'app_fosterlinks/usergroup_aircraftgroup/list';
export const COMMUNICATE_ERROR_MESSAGE_LINKABLE_SOURCE_LIST = 'links/linkable_source';
// AirportGroup
export const COMMUNICATE_ERROR_MESSAGE_GET_AIRPORT_GROUP = 'get_airport_group';
export const COMMUNICATE_ERROR_MESSAGE_GET_AIRPORT = 'get_airport';
export const COMMUNICATE_ERROR_MESSAGE_GET_CANDIDATE_AIRPORT = 'get_candidate_airport';
// Authorization
export const COMMUNICATE_ERROR_MESSAGE_LATEST_VERSION = 'latest_version';
// CopilotList
export const COMMUNICATE_ERROR_MESSAGE_LINKS_FLIGHT_LIST = 'links/flight_list';
export const COMMUNICATE_ERROR_MESSAGE_LINKS_UNLINKED_COPILOT = 'links/unlinked_copilot';
// CopilotSetting
export const COMMUNICATE_ERROR_MESSAGE_COPILOT_LIST = 'aircraft_linkage/copilot/list';
export const COMMUNICATE_ERROR_MESSAGE_COPI_SETTING_LIST = 'links/copi_setting_list';
export const COMMUNICATE_ERROR_MESSAGE_UNLINKED_COPILOT = 'links/unlinked_copilot';
export const COMMUNICATE_ERROR_MESSAGE_GET_LINKABLE_FLIGHT_PLAN = 'flightplan/get_linkable_flight_plan';
// FlightHistory
export const COMMUNICATE_ERROR_MESSAGE_PAST_DATA = 'past_data/$type$';
export const COMMUNICATE_ERROR_MESSAGE_HISTORICAL_AIRCRAFT_LIST = 'links/historical_aircraft_list';
// FlightPlan
export const COMMUNICATE_ERROR_MESSAGE_LINKS_AIRCRAFT_LIST = 'links/aircraft_list';
// FlightType
export const COMMUNICATE_ERROR_MESSAGE_GET_COMMON_FLIGHTTYPE = 'flightplan/get_common_flighttype';
// LiveCamera
export const COMMUNICATE_ERROR_MESSAGE_LIVECAMERA_GROUP = 'fosterlinks/livecamera_group';
export const COMMUNICATE_ERROR_MESSAGE_SELECTABLE_LIST = 'owner/selectable_list';
export const COMMUNICATE_ERROR_MESSAGE_SELECTABLE_LIST_CAMERA_MASTER = 'owner/selectable_list CameraMaster';
export const COMMUNICATE_ERROR_MESSAGE_IMAGE_FILE_LIST = 'date ImageFileList';
export const COMMUNICATE_ERROR_MESSAGE_IMAGE_FILE = 'get ImageFile';
export const COMMUNICATE_ERROR_MESSAGE_LATEST_IMAGE_FILE = 'latestfile LatestImageFile';
// SoraCame
export const COMMUNICATE_ERROR_MESSAGE_SORACAME_LIST = 'livecamera'
// Message
export const COMMUNICATE_ERROR_MESSAGE_UPLINK_THREAD = 'uplink/thread';
export const COMMUNICATE_ERROR_MESSAGE_QUEUECHECK = 'queuecheck';
export const COMMUNICATE_ERROR_MESSAGE_READ_GET = 'uplink/read/get';
export const COMMUNICATE_ERROR_MESSAGE_READ_UPDATE = 'uplink/read/update';
export const COMMUNICATE_ERROR_MESSAGE_MESSAGE_DESTINATION = 'links/message_destination';
export const COMMUNICATE_ERROR_MESSAGE_MESSAGEGROUP_LIST = 'uplink/messagegroup/list';
export const COMMUNICATE_ERROR_MESSAGE_UPLINK_DELETE = 'uplink/delete';
// RCInformation
export const COMMUNICATE_ERROR_MESSAGE_DAILY_GET = 'daily/get';
// UserProfile
export const COMMUNICATE_ERROR_MESSAGE_CUSTOMER_LIST = 'common/customer/list';
// UserConfigObserver UserConfigState
export const COMMUNICATE_ERROR_MESSAGE_USER_CONFIG = 'fosterlinks/user_config';
// useDisplayOperation
export const COMMUNICATE_ERROR_MESSAGE_WORKSPACE_MODE = 'fosterlinks/workspace/$mode$';
// ManualState
export const COMMUNICATE_ERROR_MESSAGE_CUSTOMER_MANUAL = 'fosterlinks/customer_manual';
// PointAreaSettingState
export const COMMUNICATE_ERROR_MESSAGE_CUSTOMER_ICON = 'fosterlinks/customer_icon';
export const COMMUNICATE_ERROR_MESSAGE_CUSTOMER_POINT = 'fosterlinks/customer_point';
export const COMMUNICATE_ERROR_MESSAGE_CUSTOMER_EXTERNAL_FILE_LIST = 'customer-ext-data/list';
// ChartState
export const COMMUNICATE_ERROR_MESSAGE_CHART_LIST = 'company-setting/chart-setting/list';
// ThresholdState
export const COMMUNICATE_ERROR_MESSAGE_THRESHOLD_COLOR_LIST = 'common/threshold-color/list';
export const COMMUNICATE_ERROR_MESSAGE_THRESHOLD_LIST = 'company-setting/threshold-setting/threshold/list';
// Airport
export const COMMUNICATE_ERROR_MESSAGE_AIRPORT = 'auth/airport $data$';
// Airway
export const COMMUNICATE_ERROR_MESSAGE_AIRWAY = 'auth/airway index';
// AMeDAS
export const COMMUNICATE_ERROR_MESSAGE_AMEDAS = 'AMeDAS $data$';
// Ameyuki
export const COMMUNICATE_ERROR_MESSAGE_AMEYUKI = 'WNI_NOWCAS_WX/list timelist';
// ControlZone
export const COMMUNICATE_ERROR_MESSAGE_AERIAL_AIRPORT = 'Aerial/airport data';
// Copilot
export const COMMUNICATE_ERROR_MESSAGE_FLIGHT = 'aircraft/flight data';
export const ERROR_MESSAGE_TRY_AGAIN_LATER_FLIGHT_413 = 'aircraft/flight data 413';
// Elevation
export const COMMUNICATE_ERROR_MESSAGE_ELEVATION = 'AeronauticalChart/$data$';
// Fix
export const COMMUNICATE_ERROR_MESSAGE_FIX = 'auth/waypoint index';
// FlightPlanList
export const COMMUNICATE_ERROR_MESSAGE_GET_FLIGHT_PLAN = 'flightplan/get_flight_plan data';
// GassScale
export const COMMUNICATE_ERROR_MESSAGE_WNI_SRF_VSCAL_GASS_HVIS = 'WNI_SRF_VSCAL_GASS_HVIS/list timelist';
export const COMMUNICATE_ERROR_MESSAGE_WNI_SRF_VSCAL_GASS_CLING = 'WNI_SRF_VSCAL_GASS_CLING/list timelist';
// Heliport
export const COMMUNICATE_ERROR_MESSAGE_HELIPORT = 'auth/heliport index';
// InformationZone
export const COMMUNICATE_ERROR_MESSAGE_INFORMATION = 'Aerial/information data';
// LfmGround
export const COMMUNICATE_ERROR_MESSAGE_JMA_SRF_LFM = 'JMA_SRF_LFM $data$';
// LfmUpper
export const COMMUNICATE_ERROR_MESSAGE_JMA_SRF_LFM_UPPER = 'JMA_SRF_LFM_UPPER $data$';
// GsmGround
export const COMMUNICATE_ERROR_MESSAGE_JMA_SRF_GSM = 'JMA_SRF_GSM $data$';
// GsmUpper
export const COMMUNICATE_ERROR_MESSAGE_JMA_SRF_GSM_UPPER = 'JMA_SRF_GSM_UPPER $data$';
// Gfs
export const COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25 = 'NCEP_MRF_GFS_0p25 $data$';
// WNI Ocean Current
export const COMMUNICATE_ERROR_MESSAGE_WNI_OCEAN_CURRENT = 'WNI_OCEAN_CURRENT $data$';
// Liden
export const COMMUNICATE_ERROR_MESSAGE_LIDEN = 'LIDEN/rect query';
// LightningNowCast
export const COMMUNICATE_ERROR_MESSAGE_JMA_NOWCAS_THNDR = 'JMA_NOWCAS_THNDR timelist';
// MetarTaf
export const COMMUNICATE_ERROR_MESSAGE_METAR_TAF_LATEST_DATA = 'latest data';
// MsmGround
export const COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM = 'JMA_SRF_MSM $data$';
// MsmUpper
export const COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM_UPPER = 'JMA_SRF_MSM_UPPER $data$';
// Navaids
export const COMMUNICATE_ERROR_MESSAGE_NAVAIDS = 'auth/navaids index';
// PointArea
export const COMMUNICATE_ERROR_MESSAGE_CUSTOMER_POINT_AVAILABLE = 'fosterlinks/customer_point/available data';
export const COMMUNICATE_ERROR_MESSAGE_POINT_AREA = 'PointArea data';
export const COMMUNICATE_ERROR_MESSAGE_CUSTOMER_EXTERNAL_FILE = 'PointArea external file data';
// Poteka
export const COMMUNICATE_ERROR_MESSAGE_POTEKA = 'POTEKA $data$';
// Synop
export const COMMUNICATE_ERROR_MESSAGE_JMA_SYNOP_1MIN = 'JMA_SYNOP_1MIN $data$';
// SST
export const COMMUNICATE_ERROR_MESSAGE_SST = 'SST $data$';
// TimeScopeCompositeRadar
export const COMMUNICATE_ERROR_MESSAGE_JMA_OBS_RADAR = 'JMA_OBS_RADAR_PRCINT/list timelist'
export const COMMUNICATE_ERROR_MESSAGE_JMA_NOWCAST_RADAR = 'JMA_NOWCAS_PRCINT_HRES/list timelist'
export const COMMUNICATE_ERROR_MESSAGE_JMA_NOWCAST_AMEDAS_RADAR = 'JMA_NOWCAS_RADAR_AMEDAS_PRCRIN/list timelist'
// TrainingAirspace
export const COMMUNICATE_ERROR_MESSAGE_TRAINING_AIRAPACE = 'TrainingAirspace data';
// TropicalCyclone
export const COMMUNICATE_ERROR_MESSAGE_TROPICAL_CYCLONE = 'TropicalCyclone $data$';
// Vaa
export const COMMUNICATE_ERROR_MESSAGE_VOLASH_ADVSRY = 'VOLASH_ADVSRY/area data';
// FlightPlanState
export const COMMUNICATE_ERROR_MESSAGE_GASS_SCALE_HVIS = 'GassSecale HVIS data';
export const COMMUNICATE_ERROR_MESSAGE_GASS_SCALE_CLING = 'GassSecale CLING data';
export const COMMUNICATE_ERROR_MESSAGE_ELEVATION_DATA = 'Elevation data';
export const COMMUNICATE_ERROR_MESSAGE_SUNRISE_DATA = 'Sunrise/Sunset data';
// Information
export const COMMUNICATE_ERROR_MESSAGE_INFORMATION_LINK = 'information';
// Topics
export const COMMUNICATE_ERROR_MESSAGE_TOPICS = 'index';
// Copilot Tooltip Settings
export const COMMUNICATE_ERROR_COPILOT_TOOLTIP_SETTINGS = 'copilot tooltip settings data';

export const COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER = 'Please try again later.';
export const COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD = 'Please reload and try again.';
